import { Component, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { IntegrationDao } from '../../../../core/services/dao/integrationDao';
import { mergeMap } from 'rxjs/operators';
import { ErrorDialogService } from '../../errorDialog/errorDialogService';
import { User } from '../../../../core/models/user';
import { IntegrationInvite } from '../../../../core/models/integrationInvite';

@Component({
  selector: 'bing',
  templateUrl: './bing.component.html',
  styleUrls: ['./bing.component.scss']
})
export class BingComponent implements OnDestroy {
  private subs = [];

  loading = false;

  accounts: Array<any> = [];
  noAccounts = false;
  disconnectOnDestroy = false;
  oauthURL = '';
  existingIntegrations = [];
  createdIntegration: any = {};
  creating = false;
  user: User;
  invites: IntegrationInvite[];
  description: string = '';
  showAccounts = false;
  integrationName;
  integrationType;
  isAdmin = false;
  emitter: EventEmitter<any>;

  constructor(
    public dialogRef: MatDialogRef<BingComponent>,
    public integrationDao: IntegrationDao,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public errorDialogService: ErrorDialogService
  ) {
    this.existingIntegrations = this.data.existingIntegrations;
    if (this.existingIntegrations.length === 0) {
      this.creating = true;
    }
    // let sub = this.integrationDao.getBingOauthUrl(this.data.brand).subscribe(res => {
    //   this.oauthURL = res['url'];
    // });
    //this.subs.push(sub);
    this.invites = this.data.invites.filter(i => i.integrations.includes(this.data.type));
    this.description = this.data.description;
    this.user = this.data.user;
    this.isAdmin = this.user ? this.user.isAdmin : false;
    this.integrationName = this.data.name;
    this.integrationType = this.data.type;
    this.emitter = this.data.emitter;
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
    if (this.disconnectOnDestroy && this.createdIntegration.id) {
      // this.integrationDao.disconnect(this.createdIntegration.id).subscribe(() => {
      //   console.log('successfully removed integration');
      // });
    }
  }

  onViewInvitesClick() {
    this.emitter.emit(this.integrationType);
    this.dialogRef.close();
  }

  save() {
    let account = this.accounts.find(a => a.accountId === this.createdIntegration.accountId);
    // let sub = this.integrationDao
    //   .update(this.createdIntegration.id, {
    //     accountId: this.createdIntegration.accountId,
    //     customerId: account.customerId,
    //     accountName: account.accountName,
    //     customerName: account.customerName,
    //     friendlyName: account.accountName + '(' + account.customerName + ')',
    //     type: 'bing'
    //   })
    //   .subscribe(
    //     res => {
    //       this.disconnectOnDestroy = false;
    //       this.createdIntegration.id = res.id;
    //       this.createdIntegration.enabled = res.enabled;
    //       this.createdIntegration.accountLinked = res.accountLinked;
    //       this.createdIntegration.friendlyName = res.friendlyName;
    //       this.dialogRef.close(this.createdIntegration);
    //     },
    //     err => console.error(err)
    //   );
    // this.subs.push(sub);
  }

  addAnother(e) {
    this.creating = true;
  }

  toggleShowAccounts() {
    this.showAccounts = !this.showAccounts;
  }

  onClick(e) {
    if (!this.oauthURL) {
      console.error('OAuth URL not loaded');
      return false;
    }
    let opened = window.open(this.oauthURL, null, 'width=800,height=850,modal=yes,alwaysRaised=yes');

    let listener = event => {
      if (event.data) {
        if (event.data.type && event.data.type === 'bing' && event.data.id !== undefined) {
          this.disconnectOnDestroy = true;
          this.loading = true;
          this.noAccounts = false;
          let intSub = this.integrationDao
              .loadById(event.data.id)
              .pipe(
                  // mergeMap(res => {
                  //   this.createdIntegration = res;
                  //   return this.integrationDao.getBingAccounts(this.createdIntegration.id);
                  // })
              )
              .subscribe(accounts => {
                this.accounts = accounts;
                if (!this.accounts.length) {
                  this.noAccounts = true;
                }
                this.loading = false;
              });
          this.subs.push(intSub);

          // remove listener
          window.removeEventListener('message', listener);

          // close window
          opened.close();
        } else {
          this.dialogRef.close();
          let title = 'Error connecting Bing Ads integration: ' + event.data.error;
          this.errorDialogService.open(title, event.data.error_description);
        }
      } else {
        this.dialogRef.close();
        let title = 'Error connecting Bing Ads integration: ' + event.data.error;
        this.errorDialogService.open(title, event.data.error_description);
      }
    }

   window.addEventListener('message', listener);
  }
}
